export default __webpack_public_path__ + "static/media/image5.aeaa2639.png";